import React, {useState} from 'react';

import {ValidationContextProvider} from 'src/contexts/validation-context/validation-context-provider';

import {CREATE_ACCOUNT_STEPS} from './steps';
import {CreateAccountDetails} from './steps/account-details';
import {CreateAccountSettings} from './steps/account-settings';
import {LicenseCreateStep} from './steps/license-create';

export const CreateAccount = () => {
    const [selectedStep, setSelectedStep] = useState(CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS);
    const [accountId, setAccountId] = useState<number | undefined>(undefined);
    const [accountEntityType, setAccountEntityType] = useState<string>('');

    if (selectedStep === CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS) {
        return (
            <ValidationContextProvider key={selectedStep}>
                <CreateAccountDetails {...{
                    onNext: () => setSelectedStep(CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS),
                    setAccountId,
                    setAccountEntityType,
                    accountId,
                }}
                />
            </ValidationContextProvider>
        );
    }

    if (selectedStep === CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS && accountId) {
        return (
            <CreateAccountSettings {...{
                accountId,
                onBack: () => setSelectedStep(CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS),
                onNext: () => setSelectedStep(CREATE_ACCOUNT_STEPS.LICENSE_CREATE),
                onRedirectToStep: setSelectedStep,
            }}
            />
        );
    }

    if (selectedStep === CREATE_ACCOUNT_STEPS.LICENSE_CREATE && accountId) {
        return (
            <ValidationContextProvider key={selectedStep}>
                <LicenseCreateStep {...{
                    accountId,
                    accountEntityType,
                    onBack: () => setSelectedStep(CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS),
                    onRedirectToStep: setSelectedStep,
                }}
                />
            </ValidationContextProvider>
        );
    }

    return null;
};
